//#region IMPORTS
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import { Order } from "../../models/order";
//#endregion

//#region INTERFACE
interface Props {
  shipHandler: () => void;
  hide?: boolean;
  order: Order;
}
//#endregion

export default function OrdersTableRowActionShip({
  shipHandler,
  order,
  hide = false,
}: Props) {
  //#region SETUP
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content="Ship order?"
        data-tooltip-variant="dark"
        data-tooltip-place="left"
        data-tooltip-id={String(order.id) + "ship"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <PaperAirplaneIcon
          className="h-5 w-5 text-sky-700 hover:cursor-pointer hover:text-sky-500"
          onClick={shipHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(order.id) + "ship"} />
    </Fragment>
  ) : null;
}
